import {
  SignInPage,
  type SignInProviderConfig,
} from '@backstage/core-components';
import {
  configApiRef,
  microsoftAuthApiRef,
  type SignInPageProps,
  useApi,
} from '@backstage/core-plugin-api';

const microsoftProvider: SignInProviderConfig = {
  id: 'microsoft-auth-provider',
  title: 'E.ON OS Login',
  message: 'Sign in using E.ONs Entra Directory.',
  apiRef: microsoftAuthApiRef,
};

export function WorkbenchSignInPage(props: SignInPageProps) {
  const configApi = useApi(configApiRef);
  const isProduction =
    configApi.getOptionalString('auth.environment') === 'production';

  // Guest is offered only outside production.
  const providers: (SignInProviderConfig | 'guest' | 'custom')[] = isProduction
    ? [microsoftProvider]
    : ['guest', microsoftProvider];

  return <SignInPage {...props} auto providers={providers} />;
}
